import { FC, ReactNode } from 'react';
import { Dropdown } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { ActivityPayload } from '@/stores';

import WorkspaceMemberHoverContent from '../WorkspaceMemberHoverContent';

interface ActiveAvatarHoverDropdownProps {
    activity?: ActivityPayload;
    avatarOpacity?: any;
    children: ReactNode;
    collaborator: any;
    overlayZIndex?: number;
    resourceId?: any;
    setAvatarOpacity?: any;
    showResourceContext?: boolean;
    tooltipPlacement?: any;
    type?: any;
}

const ActiveAvatarHoverDropdown: FC<ActiveAvatarHoverDropdownProps> = ({
    activity,
    children,
    collaborator,
    overlayZIndex,
    showResourceContext = true,
    tooltipPlacement,
}): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <Dropdown
            destroyPopupOnHide
            getPopupContainer={() => document.body}
            placement={tooltipPlacement ? tooltipPlacement : 'bottomRight'}
            overlayStyle={{
                minWidth: 16 * 20,
                maxWidth: 16 * 20,
                zIndex: overlayZIndex ?? token.zIndexPopupBase + 1500,
            }}
            popupRender={() => (
                <WorkspaceMemberHoverContent
                    activity={activity}
                    collaborator={collaborator}
                    showResourceContext={showResourceContext}
                />
            )}
        >
            <span>{children}</span>
        </Dropdown>
    );
};

export default ActiveAvatarHoverDropdown;
